module.exports = __webpack_public_path__ + "img/blood-transparent@3x.43401993.png";